var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.926,
    height: 48.038,
    viewBox: "0 0 50.926 48.038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .warning_icon {\n        fill: #55abdd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "error",
    transform: "translate(-0.001 -14.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_869",
    transform: "translate(0.001 14.519)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    className: "warning_icon",
    d: "M49.893,51.33,31.883,18.174a7.469,7.469,0,0,0-12.843,0l-.029.053L1.061,51.277a7.466,7.466,0,0,0,6.42,11.28H43.343a7.546,7.546,0,0,0,6.591-3.775A7.36,7.36,0,0,0,49.893,51.33ZM22.475,29.7a2.987,2.987,0,0,1,5.974,0V41.648a2.987,2.987,0,1,1-5.974,0V29.7Zm2.987,26.883a4.48,4.48,0,1,1,4.48-4.481A4.485,4.485,0,0,1,25.462,56.583Z",
    transform: "translate(-0.001 -14.519)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.864d44f8bdc27021d593c095dc6245ce.svg";
export { ForwardRef as ReactComponent };